import type { KeyboardEvent } from "react";

// Safari can deliver compositionend before the Enter keydown that confirmed the
// conversion, so that keydown already reads isComposing=false and may lack keyCode 229.
const COMPOSITION_END_WINDOW_MS = 50;
const compositionEndedAt = new WeakMap<EventTarget, number>();

if (typeof document !== "undefined") {
  document.addEventListener(
    "compositionend",
    (event) => {
      if (event.target) compositionEndedAt.set(event.target, event.timeStamp);
    },
    true
  );
}

function endedCompositionJustNow(e: KeyboardEvent): boolean {
  const endedAt = compositionEndedAt.get(e.target);
  return endedAt !== undefined && Math.abs(e.nativeEvent.timeStamp - endedAt) < COMPOSITION_END_WINDOW_MS;
}

export function isImeComposing(e: KeyboardEvent): boolean {
  return e.nativeEvent.isComposing || e.keyCode === 229 || e.key === "Process" || endedCompositionJustNow(e);
}

export function isEnterSubmit(e: KeyboardEvent, opts?: { allowShift?: boolean }): boolean {
  const shiftOk = opts?.allowShift || !e.shiftKey;
  return e.key === "Enter" && shiftOk && !isImeComposing(e);
}
